/** Clamp CountUp percent ends so insane IRRs do not print as scientific notation. */
export function countUpSafePercent(value) {
  const n = Number(value)
  if (!Number.isFinite(n) || Math.abs(n) > 10000) return 0
  return n
}
